<script lang="ts" setup>
import type { StepsCardRecord, StepsSectionRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: StepsSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl">
    <h2 class="mb-3xl text-center">
      {{ data.title }}
    </h2>
    <div class="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <StepsCard v-for="(step, index) in data.steps" :key="step.id" :step="step as StepsCardRecord" :step-number="index + 1" />
    </div>
  </div>
</template>

<style scoped>

</style>
